import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';

const GuideSidebar = ({ slug }) => {
  const [blog, setBlog] = useState(null);
  const [faq, setFaq] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    const fetchBlogData = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
      formData.append('page_id', slug);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.blogData}`,
          data: formData,
        });

        if (response.data.status === 'ok') {
          setBlog(response.data.list.blog);
          setFaq(response.data.list.faqs);
        } else {
          console.log('Failed to load help guide');
        }
      } catch (err) {
        console.log('Error loading help guide: ' + err.message);
      }
    };

    if (slug) fetchBlogData();
  }, [slug]);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className='bfhsd'>
      {blog && (
        <div className='blog-box'>
          <div className='blog'>
            <div className='blog-image'>
              <img
                //src={blog.image || 'https://via.placeholder.com/400x200?text=No+Image'}
                src='https://wirestay.com/assets/images/api/blog_image.webp'
                className='img-fluid'
                alt={blog.title}
              />
              <div className='date'>
                {new Date(blog.created_at).toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric',
                })}
              </div>
            </div>
            <div className='blog-content'>
              <h2>{blog.title}</h2>
              <p>{blog.short_description}</p>
              <a href={`/articles/post/${blog.blog_slug}`} target="_blank" rel="noopener noreferrer">Read More</a>
            </div>
          </div>
        </div>
      )}

      <div className="faq-sticky">
        {faq.length > 0 ? faq.map((item, index) => (
          <div key={index} className='faqs-list-section'>
            <div
              onClick={() => toggleAccordion(index)}
              className='faqs-qustn-box'
              style={{
                backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
              }}
            >
              {item.question}
              <i
                className={`fas ${activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"}`}
                style={{ transition: "transform 0.3s ease" }}
              ></i>
            </div>
            {activeIndex === index && (
              <div className='faqs-ans-box'>
                <div dangerouslySetInnerHTML={{ __html: item.answer }} />
              </div>
            )}
          </div>
        )) : (
          <p>No FAQs available</p>
        )}
      </div>
    </div>
  );
};

export default GuideSidebar;
